import { createApp } from 'vue'
import App from './Src/Search2023App.vue'



const id = '#search2023App';
const dataset = (document.querySelector(id) as HTMLElement).dataset;
// convert all data- attributes on root element to a dataset, and pass that as props to the root app.
// note that the <div id=accommodationDetailsApp></div> is replaced with the template, therefore we 
// get any data attributes before hand. NOTE: if your prop is called abc, then use data-abc="" on the element!
const app = createApp(App, { ...dataset });
app.mount(id);

